// extracted by mini-css-extract-plugin
module.exports = {"lightbox-wrap":"lightbox-wrap--3BZvM","text":"text--3Qj20","confirm":"confirm--28M6x"};